import { useSelector } from 'react-redux';
import { getProgrammaticShowSaveButton } from 'store/dealManagement/selectors';
import { getIsProgrammaticCampaignType } from 'store/dealManagement/selectors/getCampaignType';

export const useProgrammaticShowSaveButton = (): boolean => {
  const isProgrammaticCampaignType = useSelector(getIsProgrammaticCampaignType);
  const showSaveButton = useSelector(getProgrammaticShowSaveButton);

  return isProgrammaticCampaignType && showSaveButton;
};
